module.exports = __webpack_public_path__ + "img/6-2.42927ae7.png";